function path(root, sublink) {
  return `${root}${sublink}`;
}
const ROOTS = {
  main: "",
  index: "/",
  program: "/program",
  programTopfan: "/program-topfan",
  auth: "/auth",
};

export const PATH_APP = {
  main: ROOTS.program,
  index: ROOTS.index,
  insertProgram: path(ROOTS.program, "/insert"),
  insertProgramTopfan: path(ROOTS.main, "/insert-topfan"),
  notiLog: path(ROOTS.main, "/log-broadcast"),
  adminBoardCast: path(ROOTS.main, "/admin-broadcast"),
  test_notification: path(ROOTS.main, "/notification"),
  notification: path(ROOTS.main, "/notification-new"),
  notificationNew: path(ROOTS.main, "/notification-list-new"),
  groupList: path(ROOTS.main, "/groupList"),
  users: path(ROOTS.main, "/users"),
  login: path(ROOTS.auth, "/login"),
};
